export enum Environment {
  TEST = 'test',
  SI = 'staging',
  BCP = 'BCP',
  PROD = 'production',
}
